<div class="modal-header">
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body mx-3">
  <h3 *ngIf="!isCouponInvalid">{{ "search-coupon-modal.title" | translate }}</h3>
  <div *ngIf="isCouponInvalid" class="invalid-coupon-container">
    <img
      src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2016%2016'%20fill='%23000'%3e%3cpath%20d='M.293.293a1%201%200%200%201%201.414%200L8%206.586%2014.293.293a1%201%200%201%201%201.414%201.414L9.414%208l6.293%206.293a1%201%200%200%201-1.414%201.414L8%209.414l-6.293%206.293a1%201%200%200%201-1.414-1.414L6.586%208%20.293%201.707a1%201%200%200%201%200-1.414'/%3e%3c/svg%3e"
      alt=""
      height="16"
      width="16"
      class="ms-2" />
    {{ "search-coupon-modal.coupon_not_found" | translate }}
  </div>
  <form (ngSubmit)="searchCoupon()" [formGroup]="couponForm" [ngClass]="{ 'was-validated': validate }" class="d-flex flex-column w-100 gap-2">
    <div class="d-flex mt-3 mb-3 w-100 flex-column align-items-start justify-content-start">
      <label class="form-label" for="couponCode">{{ "search-coupon-modal.coupon_code" | translate }}</label>
      <input
        maxlength="7"
        [class.is-invalid]="couponForm.get('couponCode')?.invalid && couponForm.get('couponCode')?.touched"
        type="text"
        formControlName="couponCode"
        class="form-control w-100"
        placeholder="{{ 'search-coupon-modal.insert_coupon' | translate }}" />
      <div *ngIf="couponForm.get('couponCode')?.invalid && couponForm.get('couponCode')?.touched" class="text-danger">{{ "search-coupon-modal.invalid_coupon_code" | translate }}</div>
    </div>

    <div class="d-flex align-items-center gap-3 mt-4">
      <button type="submit" class="btn btn-primary" [disabled]="!couponForm.valid">
        {{ "search-coupon-modal.check_in" | translate }}
      </button>
    </div>
  </form>
</div>
